import React, { useEffect, useMemo, useState } from 'react';
const BILL_IMAGE = 'https://cdn.magicpatterns.com/uploads/vwByjRLk8agt5cTFa2CQUN/Screenshot_2026-02-10_at_5.46.21_PM.png';
interface Bill {
  id: number;
  left: number;
  width: number;
  duration: number;
  delay: number;
  opacity: number;
  swayAmount: number;
  animationType: number;
}
export function FallingMoney() {
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' ? window.innerWidth < 768 : false);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  const count = isMobile ? 5 : 12;
  const bills = useMemo<Bill[]>(() => {
    return Array.from({
      length: count
    }).map((_, i) => ({
      id: i,
      left: Math.random() * 110 - 5,
      width: isMobile ? 50 + Math.random() * 40 : 80 + Math.random() * 80,
      duration: 10 + Math.random() * 12,
      delay: Math.random() * 4,
      opacity: 0.08 + Math.random() * 0.12,
      swayAmount: 30 + Math.random() * 60,
      animationType: i % 2
    }));
  }, [count, isMobile]);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{
    zIndex: 0
  }} aria-hidden="true" data-id="element-32">
      <style data-id="element-33">
        {`
          @keyframes billFall0 {
            0% { transform: translateY(-10vh) translateX(0px) rotate(0deg); opacity: 0; }
            5% { opacity: var(--bill-opacity); }
            50% { transform: translateY(50vh) translateX(var(--sway)) rotate(180deg); }
            95% { opacity: var(--bill-opacity); }
            100% { transform: translateY(115vh) translateX(calc(var(--sway) * -0.5)) rotate(360deg); opacity: 0; }
          }
          @keyframes billFall1 {
            0% { transform: translateY(-10vh) translateX(0px) rotate(0deg); opacity: 0; }
            5% { opacity: var(--bill-opacity); }
            50% { transform: translateY(50vh) translateX(calc(var(--sway) * -1)) rotate(-180deg); }
            95% { opacity: var(--bill-opacity); }
            100% { transform: translateY(115vh) translateX(calc(var(--sway) * 0.5)) rotate(-360deg); opacity: 0; }
          }
        `}
      </style>
      {bills.map(bill => <img key={bill.id} src={BILL_IMAGE} alt="" draggable={false} loading="eager" decoding="async" style={{
      position: 'absolute',
      top: 0,
      left: `${bill.left}%`,
      width: `${bill.width}px`,
      height: 'auto',
      animationName: `billFall${bill.animationType}`,
      animationDuration: `${bill.duration}s`,
      animationDelay: `${bill.delay}s`,
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite',
      animationFillMode: 'backwards',
      opacity: 0,
      ['--bill-opacity' as string]: bill.opacity,
      ['--sway' as string]: `${bill.swayAmount}px`
    }} data-id="element-34" />)}
    </div>;
}